import {generateUUID} from '~/utils/generators';

export default class AsyncQueue {

  constructor({processParallel = 1} = {}) {
    this.processParallel = processParallel;
    this._trackerMap = new Map();
    this._queue = [];
    this._processingCount = 0;
  }

  register(promiseFn) {
    const id = generateUUID();
    const tracker = {
      isCancelled: false
    };
    const promise = new Promise((resolve, reject) => {
      tracker.resolve = resolve;
      tracker.reject = reject;
    });


    this._trackerMap.set(id, tracker);
    this._queue.push({id, promiseFn});
    this._processNext();

    return {id, promise};
  }

  cancel(id) {
    this._trackerMap.get(id).isCancelled = true;
  }

  cancelAll() {
    for (const id of this._trackerMap.keys()) {
      this.cancel(id);
    }
  }

  clear() {
    this.cancelAll();
    this._queue = [];
    this._trackerMap.clear();
    this._processingCount = 0;
  }

  async _processNext() {
    if (this._processingCount >= this.processParallel || !this._queue.length) {
      return;
    }

    this._processingCount++;
    const {id, promiseFn} = this._queue.shift();
    const tracker = this._trackerMap.get(id);
    this._processNext();

    try {
      const result = await promiseFn();
      if (tracker.isCancelled) {
        tracker.reject({isCancelled: true});
      } else {
        tracker.resolve(result);
      }
    } catch (e) {
      tracker.reject(e);
    } finally {
      this._processingCount = Math.max(this._processingCount - 1, 0);
      this._trackerMap.delete(id);
      this._processNext();
    }
  }
}
